import React from 'react';
import { Badge } from 'reactstrap';

const ServiceBadge = ({ name, count, color, textColor }) => {
  return (
    count > 0 && (
      <Badge style={{ marginRight: 4, minWidth: 20, padding: '4.5px 5px' }} color={color}>
        <span style={{ color: textColor }}>
          {count} {name}
        </span>
      </Badge>
    )
  );
};

const ServiceStatus = ({ services }) => (
  <>
    <ServiceBadge count={services.ok} color="success" textColor="white" />
    <ServiceBadge count={services.critical} color="danger" textColor="white" />
    <ServiceBadge count={services.warning} color="warning" textColor="black" />
    <ServiceBadge count={services.pending} color="info" textColor="black" />
    <ServiceBadge count={services.unknown} color="dark" textColor="white" />
  </>
);

export default ServiceStatus;
